import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Body, Title, Stack, StackItem } from '@optimus-web/core';
import { securityCloudImage } from '@mews-commander/assets';

export const UpgradeContent = () => (
    <Stack vertical spacing="200" itemAlignment="center">
        <Title level={2} align="center">
            <LocalizedText textKey={TextKey.UpgradeToConfigureCheckInFields} />
        </Title>
        <StackItem>
            <img alt="" height="64px" src={securityCloudImage} />
        </StackItem>
        <Body align="center">
            <LocalizedText textKey={TextKey.UpgradeToConfigureCheckInFieldsDescription} />
            <br />
            <LocalizedText textKey={TextKey.UpgradeToConfigureCheckInFieldsContactDescription} />
        </Body>
    </Stack>
);
